import { render } from "./AwardsPage.vue?vue&type=template&id=12db1d86&ts=true"
import script from "./AwardsPage.vue?vue&type=script&lang=ts"
export * from "./AwardsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agtalpai/Munka/hba/hba-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__